import DOMAIN_PREFIX from "./domainPrefix.js"
const IMG_PREFIX = DOMAIN_PREFIX.IMG_PREFIX

export default {
	// 页面绘制组件图片
	buttonImgUrl: IMG_PREFIX + "/static/createComponents/button.png",
	pipelineImgUrl: IMG_PREFIX + "/static/createComponents/pipeline.png",
	textImgUrl: IMG_PREFIX + "/static/createComponents/text2.png",
	imageImgUrl: IMG_PREFIX + "/static/createComponents/image.png",
	rectangleImgUrl: IMG_PREFIX + "/static/createComponents/rectangle.png",
	circleImgUrl: IMG_PREFIX + "/static/createComponents/circle.png",
	arrowImgUrl: IMG_PREFIX + "/static/createComponents/arrow.png",
	triangleImgUrl: IMG_PREFIX + "/static/createComponents/triangle.png",
	wheelImgUrl: IMG_PREFIX + "/static/createComponents/wheel.png",
	crossImgUrl: IMG_PREFIX + "/static/createComponents/cross.png",
	cross2ImgUrl: IMG_PREFIX + "/static/createComponents/crossTwo_new.png",
	cross3ImgUrl: IMG_PREFIX + "/static/createComponents/crossThree_new.png",
	cross4ImgUrl: IMG_PREFIX + "/static/createComponents/crossFour_new.png",
	videoCameraUrl:IMG_PREFIX + "/static/createComponents/videoCamera.png",
	//系统Logo
	logoImgUrl: IMG_PREFIX + "/static/controlcloudLogo.png",
	//按钮图标
	logoHome: IMG_PREFIX + "/static/logo1.png",
	logoRead: IMG_PREFIX + "/static/read.png",
	logoWrite: IMG_PREFIX + "/static/write.png",
	logoProject: IMG_PREFIX + "/static/project.png",
	logoMember: IMG_PREFIX + "/static/member.png",
	logoDelCompany: IMG_PREFIX + "/static/delCompany.png",
	logoBuy: IMG_PREFIX + "/static/buy.png",
	logoCompany: IMG_PREFIX + "/static/company.png",
	logoProduct: IMG_PREFIX + "/static/product.png",
	logoDelMember: IMG_PREFIX + "/static/delMember.png",
	logoDistribute: IMG_PREFIX + "/static/distribute.png",
	logoSelectCompany: IMG_PREFIX + "/static/selectCompany.png",
	logoAddCompany: IMG_PREFIX + "/static/addCompany.png",
	logoAgree: IMG_PREFIX + "/static/agree.png",
	logoDisagree: IMG_PREFIX + "/static/disagree.png",
	logoCheck: IMG_PREFIX + "/static/check.png",
	logoLaunch: IMG_PREFIX + "/static/launch.png",
	logoDelLaunch: IMG_PREFIX + "/static/delLaunch.png",
}